import styled from 'styled-components';
export const CardLayoutContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 24px;
  background-color: ${({ theme }) => theme.colors.beige_3};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  position: relative;
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  width: 100%;
  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.purple_2};
    cursor: pointer;
    z-index: 1;
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.appearance.box_shadow_hover};

    &:before {
      content: '';
      position: absolute;
      width: calc(100% - 2px);
      height: calc(100% - 2px);

      border: 2px solid ${({ theme }) => theme.colors.purple_2};
      top: -1px;
      left: -1px;
    }
  }
`;
export const CardLayoutInline = styled.div `
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  align-items: center;
`;
export const CardLayoutHeader = styled.div `
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;
export const CardLayoutCardContent = styled.div `
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
